import { Link } from 'react-router';
import { Card, Empty, ErrorNote, FreshnessBadge, Loading, PageHeader, SeverityBadge } from '../components/ui';
import { freshness } from '../lib/format';
import { useMe, usePlants } from '../lib/queries';

export function Plants() {
  const plants = usePlants();
  const me = useMe();

  if (plants.isPending) return <Loading />;
  if (plants.error) return <ErrorNote error={plants.error} />;

  const multipleOrgs = new Set(plants.data.map((p) => p.organization.id)).size > 1;
  return (
    <>
      <PageHeader title="Plants" />
      {plants.data.length === 0 ? (
        <Empty>
          {me.data?.platformRole
            ? 'Vardex staff see no plant data unless a customer opens support access. Organizations and plants are under Admin.'
            : 'You have no plants yet. Ask an admin in your organization for access.'}
        </Empty>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {plants.data.map((p) => {
            const f = freshness(p.sync);
            return (
              <Link key={p.id} to={`/plants/${p.slug}`} className="block">
                <Card className="h-full p-4 transition-colors hover:border-muted">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <div className="font-display text-lg font-semibold leading-tight">{p.name}</div>
                      <div className="text-sm text-muted">{multipleOrgs ? `${p.organization.name} · ` : ''}{p.slug}</div>
                    </div>
                    {p.activeAlarms.count > 0 && (
                      <span className="flex items-center gap-1.5 text-sm">
                        <SeverityBadge severity={p.activeAlarms.highestSeverity} />
                        <span className="tabular">{p.activeAlarms.count}</span>
                      </span>
                    )}
                  </div>
                  <div className="mt-4"><FreshnessBadge state={f.state} label={f.label} detail={f.detail} /></div>
                </Card>
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
}
